<template>
  <export-excel
    type="csv"
    class="export_btn"
    :name="`Volunteer List.xls`"
    :fields="custom_fields"
    :fetch="getData"
  >
    <v-icon color="white" left>mdi-chevron-right-circle-outline</v-icon>Export
  </export-excel>
</template>

<script>
import { mapState } from "vuex";

export default {
  props: {
    volunteers: {
      type: Array,
    },
  },
  computed: {
    ...mapState("Admin", ["admin"]),
  },
  data: () => ({
    custom_fields: {
      Name: "name",
      Age: "age",
      Gender: {
        field: "gender",
        callback: (value) => {
          return value == '1' ? "male" : value == '2' ? "female" : '';
        },
      },
      Address: "address",
      "Phone 1": "phone",
      "Phone 2": "phone2",
      Code: "code",
      "Both MDR and PICTS": {
        field: "both_mdr_picts",
        callback: (value) => {
          return value == 1 ? "No" : value == 2 ? "Yes" : '';
        },
      },
      "Education Status": {
        field: "data",
        callback: (value) => {
          return value == 1 ? "higher" : value == 2 ? "primary" : "secondary";
        },
      },
      Occupation: {
        field: "data",
        callback: (value) => {
          return value == 1 ? "AMW" : value == 2 ? "CHW" : "other";
        },
      },
      Township: {
        field: "township",
        callback: (value) => {
          return value['name'];
        },
      },
      Remark: "remark",
      Training: {
        field: "trainings",
        callback: (value) => {
          const wayOfTraining = [
            { id: 1, name: "On Job" },
            { id: 2, name: "New" },
            {
              id: 3,
              name: "Refresher",
            },
          ];
          const trainings = value.map((v) => {
            let type = v.type == 1 ? "In-person" : "Virtual";
            return `${
              wayOfTraining.find((w) => w.id === +v.training_type_id)?.name
            }(${type},${v.date},${v.training_duration})`;
          });
          return trainings.join(" ");
        },
      },
      "Last training": {
        field: "trainings",
        callback: (v) => {
          const wayOfTraining = [
            { id: 1, name: "On Job" },
            { id: 2, name: "New" },
            {
              id: 3,
              name: "Refresher",
            },
          ];
          if (v) {
            const lastTraining = v[v.length - 1];
            return wayOfTraining.find(
              (w) => w.id === +lastTraining?.training_type_id
            )?.name;
          }
          return "";
        },
      },
      "Last training Date": {
        field: "trainings",
        callback: (v) => {
          if (v) {
            return  v[v.length - 1]?.date;
          }
          return "";
        },
      },
    },
  }),

  methods: {
    getData() {
      if (this.volunteers.length > 0) return this.volunteers;
    },
  },
};
</script>

<style scoped>
.export_btn {
  background: #ff4081;
  border-radius: 3px;
  color: white !important;
  letter-spacing: 1px;
  text-transform: uppercase;
  width: 150px;
  padding: 5px 15px;
  margin-bottom: 1px;
  cursor: pointer;
}
</style>
